import { formatMoney, getOrgLocale } from '../../../lib/locale';

export const isGeneralLine = (li) => !!(li.item_id || li.description) && !li.material_type;

export const lineTitle = (li) => (isGeneralLine(li) ? li.description || '(item)' : li.material_type || li.description || '');

export const lineSub = (li) => {
  if (isGeneralLine(li)) {
    return [li.sku && `SKU ${li.sku}`, li.supplier_item_code && `Supplier code ${li.supplier_item_code}`].filter(Boolean).join(' | ');
  }
  return [li.grade, li.finish, li.thickness].filter(Boolean).join(' | ');
};

export const lineSize = (li) => (li.width && li.length ? `${li.width} × ${li.length} mm` : '');

export const money = (n, currency) => formatMoney(n, currency);

export const backorderNote = (li) => (li.is_backorder ? `BACK ORDER — from ${li.backorder_po_number || 'earlier PO'}` : '');

// Tax rate for a PO line from an inventory item: its own rate, or the company rate when none is set (0 = tax-free item).
export const itemTaxRate = (item) => Number(item.tax_rate ?? getOrgLocale().tax_rate) || 0;

// Whether an item's cost includes tax; items saved before the choice existed follow the company setting.
export const costIncTax = (item) => item.cost_inc_tax ?? getOrgLocale().po_prices_include_tax;

// Convert an item's cost to the PO's pricing mode (tax-inclusive or not).
export const priceForPO = (price, item, poInc) => {
  const p = Number(price) || 0;
  const itemInc = !!costIncTax(item);
  if (itemInc === !!poInc) { return p; }
  const r = itemTaxRate(item) / 100;
  return Math.round((itemInc ? p / (1 + r) : p * (1 + r)) * 10000) / 10000;
};
